import { TableCell, TableRow } from '@mui/material';
import { calcItemRows, ItemResultTable } from '../ResultTable';
import { isEmptyData } from '../../../_utils/utils';
import { getColorByLabel } from '../../../_utils/inspectionUtils';
import { Depth0RowProps } from './Depth0Row';

export type Depth1RowProps = Depth0RowProps & {
  problem: ItemResultTable;
  problemIndex: number;
};
/** 1層目までの小項目1行分 */
const Depth1Row: React.FC<Depth1RowProps> = ({
  category,
  type,
  item,
  problem,
  typeIndex,
  itemIndex,
  problemIndex,
  tableStyle,
}) => {
  return (
    <TableRow>
      {typeIndex === 0 && itemIndex === 0 && problemIndex === 0 && (
        <TableCell
          sx={tableStyle.category}
          rowSpan={category.typeResultList.reduce((rows, type) => {
            return rows + calcItemRows(type.itemResultList);
          }, 0)}
        >
          {category.label}
        </TableCell>
      )}
      {itemIndex === 0 && problemIndex === 0 && (
        <TableCell
          sx={tableStyle.type}
          rowSpan={calcItemRows(type.itemResultList)}
        >
          {type.label}
        </TableCell>
      )}
      {problemIndex === 0 && (
        <TableCell
          sx={tableStyle.item}
          rowSpan={calcItemRows(item.itemResultList)}
        >
          {item.label}
        </TableCell>
      )}
      <TableCell colSpan={2} sx={tableStyle.item}>
        {problem.label}
      </TableCell>
      <TableCell
        sx={{
          ...tableStyle.result,
          color: getColorByLabel(problem.inResult),
        }}
        colSpan={isEmptyData(item.inNumericalValue) ? 2 : 1}
      >
        {problem.inResult}
      </TableCell>
      {!isEmptyData(item.inNumericalValue) && problemIndex === 0 && (
        <TableCell sx={tableStyle.result} rowSpan={item.itemResultList.length}>
          {item.inNumericalValue}
        </TableCell>
      )}
      <TableCell
        sx={{
          ...tableStyle.result,
          color: getColorByLabel(problem.qcResult),
        }}
        colSpan={isEmptyData(item.qcNumericalValue) ? 2 : 1}
      >
        {problem.qcResult}
      </TableCell>
      {!isEmptyData(item.qcNumericalValue) && problemIndex === 0 && (
        <TableCell sx={tableStyle.result} rowSpan={item.itemResultList.length}>
          {item.qcNumericalValue}
        </TableCell>
      )}
    </TableRow>
  );
};

export default Depth1Row;
